import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldProps } from '@ngx-formly/bootstrap/form-field';
import { FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';

interface TextAreaFieldProps extends FormlyFieldProps {
  cols: number;
  rows: number;
}

@Component({
  selector: 'app-text-area-field',
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    SelectModule,
    TextareaModule,
    NgIf,
  ],
  templateUrl: './text-area-field.component.html',
  styleUrl: './text-area-field.component.scss',
})
export class TextAreaFieldComponent extends FieldType<
  FieldTypeConfig<TextAreaFieldProps>
> {
  override defaultOptions = {
    props: {
      cols: 60,
      rows: 4,
    },
  };
}
